type imp<T> = () => Promise<T>;

class DynamicLoader {
    private importList: imp<unknown>[] = [];

    public load = <T>(importFactory: imp<T>): imp<T> => {
        this.importList.push(importFactory);

        return () => this.importWithRetry(importFactory);
    };

    public preload = () => {
        this.importList.push = (a) => {
            // eslint-disable-next-line @typescript-eslint/no-floating-promises
            a();
            return 0;
        };
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        this.importList.splice(0, this.importList.length).map((t) => t());
    };

    private retryMax = 5;

    private importWithRetry = <T>(importFactory: () => Promise<T>, retry = 1): Promise<T> => {
        return new Promise<T>((resolve, reject) => {
            importFactory()
                .then((e) => {
                    resolve(e);
                })
                .catch((error) => {
                    if (retry < this.retryMax) {
                        setTimeout(() => {
                            resolve(this.importWithRetry(importFactory, retry + 1));
                        }, 1000);
                    } else {
                        reject(error);
                    }
                });
        });
    };
}

const dynamicLoader = new DynamicLoader();

export const load = dynamicLoader.load;
export const preload = dynamicLoader.preload;
